import { render, staticRenderFns } from "./sendingGoods.vue?vue&type=template&id=4b4dc461&"
import script from "./sendingGoods.vue?vue&type=script&lang=js&"
export * from "./sendingGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports